import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { SessionService } from "./session.service";

export const roleGuard: CanActivateFn = (route) => {
    const router = inject(Router);
    const sessionService = inject(SessionService);

    if (!route.data?.roles) return true;

    const canActivate = sessionService.userInRole(route.data.roles);

    if (canActivate) return true;

    return router.parseUrl("/unauthorized");
};
